import type { InterceptorStateKeys } from '@carboncopyco/types/desktop';

export const getRulesKey = (
  globalTabId: number | string
): InterceptorStateKeys => `global-tab-rules-${globalTabId}`;

export const getEditsKey = (
  globalTabId: number | string
): InterceptorStateKeys => `global-tab-edits-${globalTabId}`;

export const getVariablesKey = (
  globalTabId: number | string
): InterceptorStateKeys => `global-tab-variables-${globalTabId}`;

export const getRecordingTokenDataKey = (
  globalTabId: number | string
): InterceptorStateKeys => `global-tab-token-data-${globalTabId}`;
